export const userPath = "/user";

export const PATH = {
  Home: "/",
  Bank: "/bank",
  Deposit: "/deposit",
  Brand: "/brand",
  Withdraw: "/withdraw",
  Orders: "/orders",
  CategoryGame: "/:categoryName",
  SubGame: "/:categoryName/:providerId",
  TermsAndConditions: "/terms-and-conditions",
  tc: "/t&c",
  Promotion: "/promotion",
  PromotionDetail: "/promotion/:id",
  Download: "/download",
  liveGamePage: "/live",
  slotGamePage: "/slots",
  sportGamePage: "/sports",
  fishingGamePage: "/fishing",
  lotteryGamePage: "/lottery",
  boardGamePage: "/board-games",
  crushGamePage: "/crush-games",
  contactUs: "/contact-us",
  infoVip: "/program-vip",
  referral: "/refer/:code",
  Banner: "/banner/:id",
  User: {
    profile: userPath,
    More: userPath + "/more",
    personalDetails: userPath + "/details",
    TransactionHistory: userPath + "/transaction-history",
    Setting: userPath + "/setting",
    deposit: userPath + "/deposit",
    withdraw: userPath + "/withdraw",
    Announcement: userPath + "/messages",
    MoreExchangeRate: userPath + "/more/exchange-rate",
    MorePricePackage: userPath + "/more/price-package",
    MoreTutorialVideo: userPath + "/more/tutorial-video",
    BettingRecord: userPath + "/betting-record",
    MemberReport: userPath + "/member-report",
    UpdateInfo: userPath + "/update-info",
    changePassword: userPath + "/change-password",
    Referral: userPath + "/referral",
    memberDocuments: userPath + "/documents",
    myVip: userPath + "/vip",
    Challenge: userPath + "/challenge",
    transfer: userPath + "/transfer",
  },
  affiliatePage: "/affiliate",
};
